import Topbar from "./topbar.jsx"

export default function () {
  return {
    components: {
      Topbar
    }
  }
}



// WEBPACK FOOTER //
// ./src/standalone/topbar/index.js